import { GamePhase } from '../entities/GamePhase';
import { Sound } from '../entities/sound';
import { SupportedSound } from '../entities/SoundType';
import { UseCase } from './UseCase';
export class ChangeGamePhaseUseCase extends UseCase {
    constructor(applicationServices) {
        super();
        this.applicationServices = applicationServices;
    }
    execute(event) {
        return this.applicationServices.cleavage.retrieveCurrentGamePhase()
            .then(previousGamePhase => this.onPreviousGamePhase(event, previousGamePhase))
            .catch(error => Promise.reject(error));
    }
    onPreviousGamePhase(event, previousGamePhase) {
        return this.applicationServices.cleavage.changeGamePhase(event.gamePhase)
            .then(() => this.applicationServices.interface.changeGamePhase(event.gamePhase))
            .then(() => this.playPouffOnGamePhases(previousGamePhase))
            .catch(error => Promise.reject(error));
    }
    playPouffOnGamePhases(previousGamePhase) {
        return previousGamePhase !== GamePhase.NONE
            ? this.applicationServices.interface.playSound(new Sound(SupportedSound.POUFFF))
            : Promise.resolve();
    }
}
